import { ICheckoutPage } from '../../../../api/checkouts/types/checkout-page.type';

const filled = (value?: string | null) => !!value && value.trim() !== '';

/**
 * O checkout tem um caminho pós-compra PRÓPRIO (upsell, downsell, obrigado)?
 * Se não tem, a compra segue o obrigado da plataforma, como sempre.
 *
 * Antes a regra era só "a página de confirmação tem algum bloco". Com isso,
 * três coisas configuradas no builder simplesmente não aconteciam quando a
 * confirmação estava sem blocos, sem nenhum aviso:
 *   - o upsell ligado nunca aparecia;
 *   - o título, a mensagem e o botão do cartão de confirmação eram ignorados;
 *   - os pixels da aba "Página de obrigado" nunca disparavam.
 *
 * Qualquer uma dessas configurações é o admin dizendo que quer o caminho
 * próprio.
 */
export const hasConfirmationPage = (page?: ICheckoutPage | null): boolean => {
	if (!page) return false;
	if (page.confirmation?.length) return true;

	const settings = page.settings ?? {};

	const hero = settings.confirmation ?? {};
	if (
		filled(hero.title) ||
		filled(hero.message) ||
		filled(hero.buttonLabel) ||
		filled(hero.buttonUrl)
	) {
		return true;
	}

	const tracking = settings.confirmationTracking ?? {};
	if (
		filled(tracking.metaPixelId) ||
		filled(tracking.ga4Id) ||
		filled(tracking.googleAdsId)
	) {
		return true;
	}

	return !!settings.upsell?.enabled && !!settings.upsell?.contentId;
};
